<template>
	<ConsoleEventArg renderAs="ArgArray" :value="asArray" :serialized="serialized">Set</ConsoleEventArg>
</template>

<script>
export default {
	name: 'ArgSet',
	props: {value: Object, serialized: Object},
	computed: {
		asArray() {
			return this.value.data
		},
	},
}
</script>
